/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiAbbreviatedTalent } from './AbbreviatedTalent';
import { ApiTopic } from './Topic';
import { ApiAvAsset } from './AvAsset';

export interface VODRequest {

    id?: string;

    /**
     * Title of the media
     */
    title?: string;

    /**
     * Internal tracking name for this VOD
     */
    internal_name?: string;

    /**
     * Kind of VOD
     */
    kind?: string;

    /**
     * Description of the media
     */
    description?: string;

    duration?: string;

    hosts?: ApiAbbreviatedTalent[];

    guests?: ApiAbbreviatedTalent[];

    thumbnail_landscape1?: string;

    topics?: ApiTopic[];

    /**
     * True if this VOD covers breaking news at the time of its publishing
     */
    is_breaking_news?: boolean;

    /**
     * True if the VOD requires TYT Plus (premium) access
     */
    is_premium?: boolean;

    /**
     * True if this is post show content (ie Post Game)
     */
    is_post_show?: boolean;

    /**
     * True if this video covers Behind The Scenes content (shows TYT in the act of producing the related production)
     */
    is_bts?: boolean;

    /**
     * True if this VOD contains a TYT original sketch as part of its content
     */
    is_sketch?: boolean;

    /**
     * True if this VOD is exclusive to TYT apps
     */
    is_app_exclusive?: boolean;

    /**
     * True if this VOD is temporarily available to non-members
     */
    unlock_premium?: boolean;

    /**
     * The date that the Unlocked status on this VOD will expire
     */
    unlock_premium_expiration?: string;

    /**
     * True if the current user is entitled, false otherwise
     */
    entitled?: boolean;

    /**
     * Exposes the actual video asset. Only provided if the caller is authorized as a current TYT member
     */
    asset?: ApiAvAsset;

}

@Model('VOD')
export class ApiVOD extends BaseModel implements VODRequest {

    
    
    id: string;

    /**
     * Title of the media
     */
    
    
    title: string;

    /**
     * Internal tracking name for this VOD
     */
    
    
    internal_name: string;

    /**
     * Kind of VOD
     */
    
    
    kind: string;

    /**
     * Description of the media
     */
    
    
    description: string;

    
    
    duration: string;

    @Type('ApiAbbreviatedTalent')
    @Expand()
    hosts: ApiAbbreviatedTalent[];

    @Type('ApiAbbreviatedTalent')
    @Expand()
    guests: ApiAbbreviatedTalent[];

    
    
    thumbnail_landscape1: string;

    @Type('ApiTopic')
    @Expand()
    topics: ApiTopic[];

    /**
     * True if this VOD covers breaking news at the time of its publishing
     */
    
    
    is_breaking_news: boolean;

    /**
     * True if the VOD requires TYT Plus (premium) access
     */
    
    
    is_premium: boolean;

    /**
     * True if this is post show content (ie Post Game)
     */
    
    
    is_post_show: boolean;

    /**
     * True if this video covers Behind The Scenes content (shows TYT in the act of producing the related production)
     */
    
    
    is_bts: boolean;

    /**
     * True if this VOD contains a TYT original sketch as part of its content
     */
    
    
    is_sketch: boolean;

    /**
     * True if this VOD is exclusive to TYT apps
     */
    
    
    is_app_exclusive: boolean;

    /**
     * True if this VOD is temporarily available to non-members
     */
    
    
    unlock_premium: boolean;

    /**
     * The date that the Unlocked status on this VOD will expire
     */
    
    
    unlock_premium_expiration: string;

    /**
     * True if the current user is entitled, false otherwise
     */
    
    
    entitled: boolean;

    /**
     * Exposes the actual video asset. Only provided if the caller is authorized as a current TYT member
     */
    @Type('ApiAvAsset')
    @Expand()
    asset: ApiAvAsset;

}
